import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 7"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M4.707 3.268 8 6.56l1.414-1.414L4.707.44 0 5.147 1.414 6.56l3.293-3.293Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };